<template>
  <div>
    <v-card flat>
      <v-app-bar color="primary" short dense dark flat v-if="session">
        <v-toolbar-title>Riwayat Golongan/KP</v-toolbar-title>
        <v-spacer></v-spacer>

        <div
          class="mr-3 mt-1"
          v-if="
            session.authorities.some((item) => item === 'CRUD_ADMINISTRATOR')
          "
        >
          <rwpangkatModalAdd />
        </div>

        <div style="max-width: 300px">
          <v-tabs v-model="tab" right dark background-color="primary">
            <v-tab href="#tab-1" @click="getSIMASN()">
              <h5>IDASN</h5>
            </v-tab>

            <v-tab href="#tab-2" @click="getSAPK()">
              <h5>SIASN</h5>
            </v-tab>
          </v-tabs>
        </div>
      </v-app-bar>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item value="tab-1" class="pa-5">
          <rwpangkatSIMASN />
        </v-tab-item>
        <v-tab-item value="tab-2" class="pa-5">
          <rwpangkatSAPK />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import getData from "@/store/asn/rwpangkat/tabs";

import rwpangkatSIMASN from "@/components/asn/profil/rwpangkat/rwpangkat";
import rwpangkatSAPK from "@/components/asn/profil/rwpangkat/SAPK_rwpangkat_Modal";
import rwpangkatModalAdd from "@/components/asn/profil/rwpangkat/ModalAdd";

export default {
  name: "DataUtama",

  components: {
    rwpangkatSIMASN,
    rwpangkatSAPK,
    rwpangkatModalAdd,
  },

  computed: {
    dataSAPK: {
      get() {
        return getData.state.tabSAPK;
      },

      set(value) {
        getData.commit("getSAPK", value);
      },
    },
  },

  data: () => ({
    tab: null,
    session: "",
  }),

  mounted() {
    this.session = JSON.parse(Cookie.dec(Cookie.get("myCookie")));
  },

  methods: {
    getSAPK() {
      getData.commit("getSAPK", true);
      getData.commit("getSIMASN", false);
    },
    getSIMASN() {
      getData.commit("getSIMASN", true);
      getData.commit("getSAPK", false);
    },
  },
};
</script>
